import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../../modal/ConfirmModal';
import Form from '../../../form/Form';
import AdditionalPaymentFormConfig from './AdditionalPaymentFormConfig';
import { useOffer } from '../../../../context/OfferProvider';
import LightButton from '../../../button/LightButton';

const AdditionalPayment = () => {
  const { manualAdditionalPayments, setManualAdditionalPayments, canModifyPayments } =
    useOffer();

  const [open, setOpen] = useState(false);
  const [formReady, setFormReady] = useState(false);
  const [payment, setPayment] = useState();

  if (!canModifyPayments) {
    return null;
  }

  const addPayment = () => {
    setManualAdditionalPayments([
      ...manualAdditionalPayments,
      {
        uuid: `${Math.floor(Math.random() * 999999)}`,
        amount: parseFloat(payment.amount),
        description: payment.description,
      },
    ]);
    setPayment(undefined);
    setOpen(false);
  };

  return (
    <>
      <LightButton
        onClick={() => setOpen(true)}
        size="sm"
        title="Dodaj opłatę dodatkową"
      >
        <FontAwesomeIcon icon={faPlus} className="me-1" />
        Dodaj opłatę
      </LightButton>

      {open && (
        <ConfirmModal
          show={open}
          setShow={setOpen}
          size="md"
          title="Dodaj opłatę dodatkową"
          ready={formReady}
          onConfirm={addPayment}
          form={
            <Form
              initialData={{}}
              onReadyUpdate={setFormReady}
              formDataChanged={setPayment}
              noActions={true}
              fields={AdditionalPaymentFormConfig}
            />
          }
        />
      )}
    </>
  );
};

export default AdditionalPayment;
